import "./Lookbook.module.css";
import Header from "@/reusable_sections/Header";
import ColorCutGallery from "./sections/ColorCutGallery";
import BehindTheChair from "./sections/BehindTheChair";
import GetTheLook from "./sections/GetTheLook";
import Footer from "@/reusable_sections/Footer";
export default function LookbookPage() {
  return <div>
      <Header />
      <ColorCutGallery />
      <BehindTheChair />
      <GetTheLook />
      <Footer />
    </div>;
}